export * from './actions';
export * from './mutations';
export * from './state';

export const namespaced = true;
